<template>
    <div class="barplotly"> 
      <div :id="divId">
      </div>
    </div>
</template>

<script>
  
  import { sample } from 'lodash'
import generateBarplot from '../plotly/barplotly'
import sampleMeta from '../refs/sampleMeta'

  export default {
    name: "barplotly",

    props: [ 'track', 'trackDetails', 'sampleMeta', 'stratifyVar'],

    data() {
      return {
      }
    },

    computed: {
      divId() { return `${this.track}-barplot` },
      SampleDashboard_data() { 
        let res = {}
        return res
      },
      percentView() { return this.$store.state.SampleDashboard_percentView },
      cohortSelected() { return this.$store.state.SampleDashboard_cohortSelected },
      // stratifyVar() { 
      //   return this.$store.state.SampleDashboard_stratifyVar[] 
      // },
    },

    watch: {
      percentView() { this.barplot() },
      cohortSelected() { this.barplot() },
      sampleMeta() { this.barplot() },
      trackDetails() { this.barplot() },
      track() { this.barplot() },
      stratifyVar() { this.barplot() },
    },

    methods: {
      barplot() {
        generateBarplot({
          divId: this.divId,
          percentView: this.percentView,
          sampleMeta:  this.sampleMeta,
          trackDetails: this.trackDetails,
          track: this.track,
          cohortSelected: this.cohortSelected,
          stratifyVar: this.stratifyVar
        })
      }
    },

    mounted() {
      this.barplot()
    },
  }

</script>

<style scoped>
    .barplotly {
      border-top: solid 1px #ededed;
      width: 100%;
      min-width: 340px;
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
</style>